import _, { get } from "lodash";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { useURLParamsGetter } from "~/hooks/useURLParamsSetter";
import {
  useCheckListGetterLazyQuery,
  useGetDealerQuery,
} from "~/schemas/generated/graphql";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";

interface UseChecklistsPageOptions {
  departmentIds?: string[];
  detailId?: string;
  withAutoCrmidGuard?: boolean;
}

export const useChecklistsPage = (options?: UseChecklistsPageOptions) => {
  const { page, count } = useURLParamsGetter<{
    page: number;
    count: number;
    openChildModal: string;
    dealerName: string;
  }>();
  const [checklists, setChecklists] = useState([]);
  const [total, setTotal] = useState(0);
  const history = useHistory();
  const [getChecklists, getChecklistsState] = useCheckListGetterLazyQuery({
    fetchPolicy: "no-cache",
  });
  const currentDealerId = useCurrentDealerId();

  const { data: dealerData } = useGetDealerQuery({
    variables: {
      DealerId: currentDealerId,
    },
    fetchPolicy: "no-cache",
  });

  const getCheckListsHandler = () => {
    const guard = options?.withAutoCrmidGuard
      ? dealerData && dealerData.DealerGetter.getDealer.autoCRMID
      : dealerData;
    if (guard) {
      getChecklists({
        variables: {
          page: Number(page),
          count: Number(count),
          dealerAutoCrmid: dealerData.DealerGetter.getDealer.autoCRMID,
          ...(options?.departmentIds
            ? { departmentIds: options.departmentIds }
            : {}),
          isDeleted: false,
        },
      });
    }
  };
  useEffect(() => {
    getCheckListsHandler();
  }, [page, count, dealerData]);

  useEffect(() => {
    if (getChecklistsState.loading) getChecklistsState.data = undefined;
    if (getChecklistsState.data) {
      const requestData = get(
        getChecklistsState.data,
        "CheckListGetter.getCheckLists",
      );
      if (requestData) {
        if (options?.detailId) {
          const filteredItems = requestData.items.filter(
            (item) => item.id === options.detailId,
          );
          const updatedItems = filteredItems.map((item) => ({
            ...item,
          }));

          setChecklists(Array.isArray(updatedItems) ? updatedItems : []);
        } else {
          const updatedItems = _.orderBy(
            requestData.items,
            ["createdAt"],
            ["desc"],
          ).map((item) => ({
            ...item,
            result: `${item.actualPoints} / ${item.maxPoints} ${item.result}%`,
          }));

          setChecklists(updatedItems);
          setTotal(requestData.total);
        }
      }
    }
  }, [getChecklistsState.loading, options?.detailId]);

  const handleViewClick = ({ id }) => {
    history.push(`/checklists/${id}`);
  };

  return { checklists, total, page, count, handleViewClick };
};
